import { Alert, Center, Loader, Stack, Title } from "@mantine/core";
import { ChangelogList } from "@nodus/ui";
import { useQuery } from "@tanstack/react-query";

import { changelogApi } from "@/lib/api/client";

// Release notes for the member portal — portal-surface entries only,
// released versions only (the backend filters). Linked from the version
// text on the account page.
export default function ChangelogPage() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["changelog"],
    queryFn: ({ signal }) => changelogApi.get(signal).then((r) => r.data),
  });

  return (
    <Stack p="md" gap="lg" maw={760} mx="auto">
      <Title order={2}>What&apos;s new</Title>
      {isLoading && (
        <Center py="xl">
          <Loader />
        </Center>
      )}
      {isError && <Alert color="red">Failed to load release notes — try again.</Alert>}
      {data && <ChangelogList versions={data.versions} />}
    </Stack>
  );
}
